export function multiplyDecimalTwo(a: number, b: number) {
  return Math.round((a * b) / 100);
}

export const DECIMAL_KEY = '.';

const FORMAT_DECIMAL_TWO_AS_STRING_REGEX = /\d(?=(\d{3})+\.)/g;
export function formatDecimalTwoAsString(val: number) {
  return (val / 100).toFixed(2).replace(FORMAT_DECIMAL_TWO_AS_STRING_REGEX, '$&,');
}

export function formatDecimalTwoAsShortString(val: number) {
  return parseFloat((val / 100).toFixed(2))
    .toString()
    .replace(FORMAT_DECIMAL_TWO_AS_STRING_REGEX, '$&,');
}

export function formatDecimalTwoAsMoney(val: number, negativeAsParen = true) {
  if (negativeAsParen && val < 0) {
    return `($${formatDecimalTwoAsString(-val)})`;
  }
  return `$${formatDecimalTwoAsString(val)}`;
}

export function formatStringAsDecimalTwo(val: string): number {
  let nonDecimalPart;
  let decimalPart;

  if (val.indexOf(DECIMAL_KEY) >= 0) {
    const [first, second] = val.split(DECIMAL_KEY);
    if (first.length === 0) {
      nonDecimalPart = 0;
    } else {
      nonDecimalPart = 100 * Number(first);
    }
    if (second.length === 0) {
      decimalPart = 0;
    } else {
      decimalPart = Number(second);
      if (decimalPart < 10) {
        decimalPart *= 10;
      } else {
        while (decimalPart > 10) {
          decimalPart /= 10;
        }
        decimalPart = Math.round(decimalPart);
      }
    }
  } else {
    nonDecimalPart = 100 * Number(val);
    decimalPart = 0;
  }
  return nonDecimalPart + decimalPart;
}

export function numberToDecimalTwo(num: number) {
  return Math.round(num * 100);
}

export function decimalTwoToNumber(decTwo: number) {
  return decTwo / 100;
}
